import { useCallback, useEffect, useRef, useState } from 'react';

import sectorEndpoint from '../../../../api/services/sectorEndpoint';

export const useFetchDepartments = () => {
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const isMounted = useRef(true);

  const fetchAllDepartments = useCallback(async () => {
    setLoading(true);
    if (departments.length === 0) {
      try {
        const response = await sectorEndpoint.getSectors();
        if (response.status === 200) {
          if (isMounted.current) setDepartments(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllDepartments().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllDepartments]);

  return {
    loading,
    departments,
  };
};
